export enum OrderSource {
    MobileApp = 'MobileApp',
    Web = 'Web',
}
